var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import config from '@/config';
import api from '@/shared/api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import moment from 'moment';
import { IntraCompanyQueryKey } from './queryKey';
export var useGetIntraCompanyOverviewDetails = function (filters, relationCompanyId, userCompanyId) {
    var _a;
    var intl = useIntl();
    var _b = useInfiniteQuery([IntraCompanyQueryKey.Details, relationCompanyId, userCompanyId], function (_a) {
        var signal = _a.signal, pageParam = _a.pageParam;
        return api.base
            .get("".concat(config.appUrls.api, "/api/IntraCompany/Details"), {
            params: __assign(__assign({}, filters), { dateFrom: filters.dateFrom ? moment(filters.dateFrom).toISOString() : null, dateUntil: filters.dateUntil ? moment(filters.dateUntil).toISOString() : null, relationCompanyId: relationCompanyId, userCompanyId: userCompanyId, sort: ['RegistrationDate', 'RelationDisplayName', 'RegistrationId'], sortAsc: false, take: 100, page: pageParam !== null && pageParam !== void 0 ? pageParam : 0 }),
            signal: signal,
        })
            .then(function (res) { return res.data; });
    }, {
        enabled: true,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        getNextPageParam: function (lastPage, allPages) {
            return lastPage.length === 100 ? allPages.length : undefined;
        },
        notifyOnChangeProps: 'all',
    }), data = _b.data, isLoading = _b.isLoading, error = _b.error, fetchNextPage = _b.fetchNextPage, hasNextPage = _b.hasNextPage, isFetchingNextPage = _b.isFetchingNextPage;
    return {
        data: (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a.flat(1),
        error: error,
        isLoading: isLoading,
        fetchNextPage: fetchNextPage,
        hasNextPage: hasNextPage,
        isFetchingNextPage: isFetchingNextPage,
    };
};
